import type { ReactNode } from 'react'
import React from 'react'

import type { MuxPlayerProps } from '@mux/mux-player-react'
import MuxPlayerComponent from '@mux/mux-player-react'

import * as S from './styled'

type Props = MuxPlayerProps & {
  children?: ReactNode
}

export const MuxPlayer = ({ children, ...props }: Props) => (
  <S.Container>
    <S.Global />
    <MuxPlayerComponent {...props} preferPlayback="mse" />
    {children}
  </S.Container>
)
